import React from 'react';

export interface Sign8IconProps {}

export const Sign8Icon: React.FC<Sign8IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 2.75C7.41015 2.75 4.5 5.66015 4.5 9.25V21H7.5V9.25C7.5 7.317 9.067 5.75 11 5.75C12.933 5.75 14.5 7.317 14.5 9.25V15.3655L10.7185 14.0287C10.4582 13.9367 10.1725 14.0731 10.0805 14.3335C10.0209 14.5021 10.0559 14.6897 10.1722 14.8255L16.0259 21.6552L21.8796 14.8255C22.0593 14.6159 22.035 14.3002 21.8254 14.1205C21.6896 14.0041 21.5019 13.9691 21.3333 14.0287L17.5 15.384V9.25C17.5 5.66015 14.5899 2.75 11 2.75Z"
        fill="#192033"
      />
    </svg>
  );
};
